import React from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import LiveMap from "@/components/LiveMap";

const LABEL = { offering: "Ringing CHELA", accepted: "Accepted", unassigned: "NO CHELA \u2014 assign manually", passing: "Passing to next" };
const RES = { offered: "ringing", accepted: "accepted", declined: "declined", no_response: "no response" };

export default function DispatchInfo({ b, reload }) {
  const send = async () => {
    try { await api.post(`/admin/bookings/${b.id}/dispatch`); toast.success("Sent to CHELA team"); reload(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not send"); }
  };
  const markPaid = async () => {
    await api.post(`/admin/bookings/${b.id}/payout-paid`); toast.success("Marked paid"); reload();
  };
  const photos = b.job_photos || {};
  return (
    <div data-testid={`dispatch-${b.id}`} className="mt-3 rounded-xl border border-[#E5E0D8] bg-white p-3 space-y-2 text-sm">
      <div className="flex flex-wrap items-center gap-2">
        <b>CHELA app:</b>
        <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${b.dispatch_status === "unassigned" ? "bg-[#C0392B] text-white" : "bg-[#F3EFEA]"}`}>{LABEL[b.dispatch_status] || "Not sent"}</span>
        {b.job_status && <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-[#121316] text-white uppercase">{b.job_status}</span>}
        {b.job_status !== "done" && b.dispatch_status !== "accepted" && <button data-testid={`dispatch-send-${b.id}`} onClick={send} className="text-xs font-bold px-3 py-1 rounded-full bg-[#E05624] text-white">{b.dispatch_status ? "Restart ringing" : "Send to CHELA team"}</button>}
      </div>
      {(b.offer_history || []).length > 0 && (
        <div className="text-xs text-[#5A5D65]">{b.offer_history.map((h) => `${h.name}: ${RES[h.result] || h.result}`).join(" \u2192 ")}</div>
      )}
      {b.job_status === "assigned" && b.chela_loc && <LiveMap loc={b.chela_loc} testid={`admin-live-map-${b.id}`} className="w-full h-48" />}
      {b.dispatch_status === "accepted" && b.job_status === "assigned" && b.pay_token && (
        <a data-testid={`send-track-${b.id}`} target="_blank" rel="noreferrer"
          href={`https://wa.me/${(b.phone || "").replace(/\D/g, "").replace(/^(\d{10})$/, "91$1")}?text=${encodeURIComponent(`Namaste ${b.name} ji 🙏\nAapka CHELA ${b.worker_name || ""} aapki booking ke liye nikal chuka hai. Live track karein:\n${window.location.origin}/track/${b.pay_token}\n\nYour CHELA is on the way. Track live here.\n— CHELA`)}`}
          className="inline-block text-xs font-bold px-3 py-1.5 rounded-full bg-[#25D366] text-white">Send live tracking link to customer</a>
      )}
      {(photos.before || photos.after) && (
        <div className="flex gap-2">
          {["before", "after"].map((k) => photos[k] && (
            <a key={k} href={photos[k]} target="_blank" rel="noreferrer" className="text-center text-xs">
              <img src={photos[k]} alt={k} className="h-20 w-20 object-cover rounded-lg border" />{k}
            </a>
          ))}
        </div>
      )}
      {b.payout_status && (
        <div className="flex items-center gap-2">
          <b className={b.payout_status === "paid" ? "text-[#1B8A4B]" : "text-[#E05624]"}>Pay {b.worker_name}: {"\u20b9"}{b.payout_amount} {"\u00b7"} {b.payout_status === "paid" ? "PAID" : "DUE"}</b>
          {b.payout_status === "due" && <button data-testid={`payout-paid-${b.id}`} onClick={markPaid} className="text-xs font-bold px-3 py-1 rounded-full bg-[#1B8A4B] text-white">Mark CHELA paid</button>}
        </div>
      )}
    </div>
  );
}
